import { combineReducers } from 'redux';
import { ADD_ACTION_MOVIES,ADD_SEARCH_TITLE,ADD_MOVIE_VIDEO,ADD_MOVIE_BACK,ADD_MOVIE_DETAILS,ADD_BOLLYWOOD_MOVIES,ADD_COMEDY_MOVIES,ADD_HOLLYWOOD_MOVIES,ADD_HORROR_MOVIES,ADD_MORE_MOVIES,ADD_SEARCH_RESULT, ADD_TRENDING_MOVIE } from '../actions'
const initialHomeState = {
    bollywood:[],
    hollywood:[],
    action:[],
    trending:{},
    comedy:[],
    horror:[]
}

export function xHome(state=initialHomeState,action) {

    switch(action.type){
        case ADD_ACTION_MOVIES:
            console.log('Action')
            return{
                ...state,
                action:action.movies
            }
        case ADD_BOLLYWOOD_MOVIES:
            console.log('Bollywood')
                console.log(action.movies);
                return{
                    ...state,
                    bollywood:action.movies
                }
        case ADD_COMEDY_MOVIES:
            console.log('Comedy')
            return{
                ...state,
                comedy:action.movies
            }
        case ADD_HOLLYWOOD_MOVIES:
            return{
                ...state,
                hollywood:action.movies
            }
        case ADD_HORROR_MOVIES:
            return{
                ...state,
                horror:action.movies
            }    
        case ADD_TRENDING_MOVIE:
            return{
                ...state,
                trending:action.movie
            }    
        default:return state;
    }
}

const initialSearchState = {
    title:String,
    searchResult:[]
}

export function xSearch(state=initialSearchState,action){
    switch(action.type){
        case ADD_SEARCH_RESULT:
            return{
                ...state,
                searchResult:action.movies
            }
        case ADD_SEARCH_TITLE:
            return{
                ...state,
                title:action.title
            }    
        default:
            return state;    
    }
}

const initialDetailsState = {
    movie:{},
    backdrop:String,
    videos:[],
    more:[]
}

export function xDetails(state=initialDetailsState,action) {
      switch(action.type){
          case ADD_MOVIE_DETAILS:
              return{
                ...state,
                movie:action.movie
              }
           case ADD_MOVIE_VIDEO:
               return {
                   ...state,
                   videos:action.data
               }
           case ADD_MOVIE_BACK:
               return{
                   ...state,
                   backdrop:action.back
               }       
           case ADD_MORE_MOVIES:
               return{
                   ...state,
                   more:action.data
               }    
           default:
               return state    
      }
}


const theme = {
    dark:true
}


// export function changeTheme(state=theme, action){
//      if(action.type==CHANGE_THEME){
//          return{
//              dark:!state.dark
//          }
//      }
//      return state

// }

const initialRootState = {
    home:initialHomeState,
    search:initialSearchState,
    details:initialDetailsState,
    theme:theme
}



export default combineReducers({
    xHome,
    xSearch,
    xDetails
});